import { X, Settings } from "lucide-react";

interface DocToHtmlPreviewHeaderProps {
  displayTitle: string;
  onInfo?: () => void;
  onClose: () => void;
  isInfoPanelOpen: boolean;
}

export function DocToHtmlPreviewHeader({
  displayTitle,
  onInfo,
  onClose,
  isInfoPanelOpen,
}: DocToHtmlPreviewHeaderProps) {
  return (
    <div
      id="doc-preview-header"
      className={`bg-white border-b border-gray-200 px-6 py-2 flex items-center justify-between transition-all duration-300 ${
        isInfoPanelOpen ? "bg-white/90 backdrop-blur-sm" : ""
      }`}
    >
      <div>
        <h1 className="text-lg font-normal text-gray-900">
          Preview: {displayTitle || "Untitled Document"}
        </h1>
      </div>
      <div className="flex items-center gap-2">
        {onInfo && (
          <button onClick={onInfo} className="text-xs px-3 py-1.5 btn-primary">
            <Settings className="w-3 h-3" />
            Form Info
          </button>
        )}
        <button onClick={onClose} className="btn btn-transparent">
          <X className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
}

export default DocToHtmlPreviewHeader;
